import styled, { css } from 'styled-components';
import { Box, Text } from '@rsos/components/capstone/base';
import { BP_LAPTOP } from '@rsos/constants/breakpoints';
import { RowBox } from './common.styles';

const COPY_BTN_WIDTH = 68;

export const AddressBox = styled(Box).attrs(({ isCompact }) => ({
  p: isCompact ? 0 : '0px 8px 8px 8px',
  align: 'stretch',
  color: 'primaryText',
}))`
  width: 100%;
  //  NOTES: unset/100% width will stretch the UI and affect truncate
  //  when hovered over since copyButton will go from display:none to display:flex
  ${({ responsive }) =>
    responsive &&
    css`
      width: 230px;
      @media (max-width: ${BP_LAPTOP}px) {
        width: 100%;
      }
    `};
`;

export const Address = styled(Text).attrs(
  ({ isCompact, isHistoricLocation }) => ({
    size: isCompact ? 'small' : 'large',
    fontWeight: 'bold',
    my: isHistoricLocation ? 'auto' : 1,
    mb: isHistoricLocation ? 'auto' : 0,
  }),
)`
  max-width: ${props => (props.dataLocation ? '100%' : '230px')};
  width: ${props => (props.isHistoricLocation ? '170px' : '100%')};
`;

export const InternationalAddress = styled(Address).attrs({
  fontWeight: 'regular',
})``;

export const ALISingleLineAddress = styled(Address).attrs({
  fontWeight: 'regular',
})``;

export const CityRegion = styled(Address).attrs(({ noAddress }) => ({
  color: noAddress && 'secondaryText',
  fontWeight: 'regular',
}))``;

export const TextWrapper = styled(Address).attrs({
  my: 0,
  ellipsis: true,
})`
  white-space: nowrap;
`;
export const FadedTextWrapper = styled(TextWrapper).attrs({
  fontWeight: 'regular',
  color: 'secondaryText',
})``;

export const EmptyAddress = styled(CityRegion).attrs(({ secondary }) => ({
  size: secondary ? 'small' : 'large',
}))``;

export const AddressContainer = styled(Box).attrs({
  position: 'relative',
})`
  display: flex;
  border-radius: ${props => props.br || '0'};
  @media (max-width: ${BP_LAPTOP}px) {
    flex-direction: ${props =>
      props.isHistoricLocation || props.isCentralStation ? 'column' : 'row'};
  }
  flex-wrap: nowrap;
  width: 100%;
`;

export const AddressContainerWithCopy = styled(RowBox).attrs()``;

export const HomeStreet = styled(Address).attrs()`
  ${AddressContainerWithCopy}:hover & {
    width: ${props =>
      props.isHoverable ? `calc(100% - ${COPY_BTN_WIDTH}px)` : `100%`};
  }
  @media (max-width: ${BP_LAPTOP}px) {
    text-overflow: unset;
    white-space: none;
    overflow: unset;
    width: auto;
  }
`;

export const SecondaryAddressWrapper = styled(Box).attrs({
  position: 'relative',
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: 'lightLineDivider',
})`
  display: flex;
  border-radius: ${props => props.br || '0'};
  @media (max-width: ${BP_LAPTOP}px) {
    flex-direction: column;
    width: 100%;
  }
  flex-wrap: nowrap;
`;
